import {hybridQueryParamsUrlStrategy} from "./strategies/hybrid_query_params_url_strategy";
import {IOfferListUrlStrategy} from "./types/IOfferListUrlStrategy";

/** Switch to `friendlyPathUrlStrategy` to serve every filter combination as a static friendly path again. */
const activeOfferListUrlStrategy: IOfferListUrlStrategy = hybridQueryParamsUrlStrategy;

let strategyOverride: IOfferListUrlStrategy | null = null;

export const getOfferListUrlStrategy = (): IOfferListUrlStrategy => strategyOverride ?? activeOfferListUrlStrategy;

/** Test-only switch. Pass `null` to use the active strategy again. */
export const setOfferListUrlStrategyForTests = (strategy: IOfferListUrlStrategy | null) => {
    strategyOverride = strategy;
};
import {hybridQueryParamsUrlStrategy} from "./strategies/hybrid_query_params_url_strategy";
import {IOfferListUrlStrategy} from "./types/IOfferListUrlStrategy";

/** Switch to `friendlyPathUrlStrategy` to serve every filter combination as a static friendly path again. */
const activeOfferListUrlStrategy: IOfferListUrlStrategy = hybridQueryParamsUrlStrategy;

let strategyOverride: IOfferListUrlStrategy | null = null;

export const getOfferListUrlStrategy = (): IOfferListUrlStrategy => strategyOverride ?? activeOfferListUrlStrategy;

/** Test-only switch. Pass `null` to use the active strategy again. */
export const setOfferListUrlStrategyForTests = (strategy: IOfferListUrlStrategy | null) => {
    strategyOverride = strategy;
};
